import { CreateOsaNode, LocationCoordinates, OsaNode } from "../models/OsaNode";
import * as turf from "@turf/turf";

export function convertNodeToCreateNodeRequest(node: OsaNode): CreateOsaNode {
  return {
    osaWayId: node.osaWayId,
    name: node.name,
    latitude: node.latitude,
    longitude: node.longitude,
    altitude: node.altitude,
    index: node.index,
    dateTime: node.dateTime,
    photo: node.photo
      ? {
          image: node.photo.url,
          source: node.photo.source,
        }
      : null,
  };
}

export function calculateDistance(
  startLocation: LocationCoordinates,
  endLocation: LocationCoordinates,
) {
  const start = [startLocation.latitude, startLocation.longitude];
  const to = [endLocation.latitude, endLocation.longitude];
  const distanceFromX = Math.round(
    turf.distance(start, to, { units: "meters" }),
  );
  return distanceFromX;
}

export function forEachNextNode(
  fromNode: OsaNode,
  allNodes: OsaNode[],
  block: (node: OsaNode) => void,
) {
  allNodes.reduce((applyChange, node) => {
    if (applyChange || node.id === fromNode.id) {
      block(node);
      return true;
    }
    return false;
  }, false);
}
